import { atom } from 'jotai';
import { ReactElement } from 'react';

export interface IItem<T> {
  id: string | number;
  onClick: (context: T) => void;
  icon: ReactElement;
  label: string;
  context: T;
  disabled?: boolean;
  color?: 'primary' | 'secondary' | 'error' | 'success' | 'warning' | 'info';
}

export interface IContextMenuAtom<T> {
  items: Array<IItem<T>>;
  anchorEl: HTMLElement | null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const contextMenuAtom = atom<IContextMenuAtom<any> | null>(null);
